import * as React from "react";
import { style } from "typestyle";
import { White } from "@traceair/tds";
import { FunctionComponent } from "react";

interface INavLabelProps {
  onClick?: () => void;
  label: string | null;
}
const NavLabel: FunctionComponent<INavLabelProps> = ({
  onClick,
  label,
}: INavLabelProps) => (
  <div
    onClick={onClick || (() => null)}
    className={style({
      color: White,
      fontSize: "20px",
      fontWeight: 300,
      whiteSpace: "nowrap",
    })}
  >
    {label || ""}
  </div>
);

export default NavLabel;
